import * as React from 'react'
import * as cn from 'classnames'
import * as styles from './Hover.module.scss'
import { BaseComponentProps, extractClassNamesFromProps } from '../Common'

interface HoverProps extends BaseComponentProps {
    contentBlocks: (React.ReactChild | React.ReactChild[])[]
    placeholderClassName?: string
    onMouseOver?: (event: React.MouseEvent<HTMLDivElement>) => void
    onMouseLeave?: (event: React.MouseEvent<HTMLDivElement>) => void
    onFocusCapture?: (event: React.FocusEvent<HTMLDivElement>) => void
    onBlurCapture?: (event: React.FocusEvent<HTMLDivElement>) => void
}


export class Hover extends React.Component<HoverProps> {

    constructor(props: HoverProps) {
        super(props)

    }

    render() {
        return (<div className={styles.outerWrapper}>

            { //If included, this is a conditionally displayed empty box used to prevent layout
                // changes while the Hover and its contents are postion: absolute
                this.props.placeholderClassName &&
                <div className={cn(styles.placeholder,
                    this.props.placeholderClassName)}>
                </div>}
            <div
                className={extractClassNamesFromProps(this.props, styles.Hover)}
                onMouseOver={this.props.onMouseOver}
                onMouseLeave={this.props.onMouseLeave}
                onFocusCapture={this.props.onFocusCapture}
                onBlurCapture={this.props.onBlurCapture}>
                {this.props.children}

                <div className={styles.visibleWrapper} >
                    <div className={styles.contentWrapper} >
                        {this.props.contentBlocks.map((block, i) =>
                            <div key={`line-${i}`} className={styles.contentBlock}>
                                {block}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
        )
    }
}